import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideCalendarX, LucideRocket, LucideSignature } from '@lucide/angular';
@Component({
  selector: 'app-signature-th',
  imports: [
    MatIconModule,
    MatTooltipModule,
    MatSortModule,
    LucideRocket,
    LucideCalendarX,
    LucideSignature,
  ],
  templateUrl: './signature-th.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./signature-th.scss'],
})
export class SignatureTh {}
